import { all } from 'redux-saga/effects';
import interpreter from './interpreter';
import loadQueryParams from './load-query-params';
import probing from './probing';

export default function* rootSaga() {
  yield all([ interpreter(), 
              probing(),
              loadQueryParams()
              ]);
};
